import React from 'react';
import { AutoComplete, Input } from 'antd';
import { SCHOOL_OPTIONS } from '../../constants/schools';

// Searchable school picker that still accepts any school not on the list.
// Behaves like a plain text field for the form, so the stored value is the name.
const filterSchool = (input, option) =>
  (option?.value ?? '').toLowerCase().includes(input.trim().toLowerCase());

const SchoolNameInput = ({ value, onChange, placeholder, prefix, style, ...rest }) => (
  <AutoComplete
    value={value}
    onChange={onChange}
    options={SCHOOL_OPTIONS}
    filterOption={filterSchool}
    style={{ width: '100%', ...style }}
    {...rest}
  >
    <Input prefix={prefix} placeholder={placeholder} allowClear />
  </AutoComplete>
);

export default SchoolNameInput;
